(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-boardbag-fit"] && !Shopify.designMode) return;
  try {
    
(function(){
 'use strict';
 const ft=n=>Math.floor(n/12)+'′'+(Math.round(n%12*10)/10)+'″';
 const esc=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 function matchBag(data,shape,length,width,carry){
  if(!Number.isFinite(length)||length<=0)return {error:'length_error'};
  let keys={short:['short','fun'],fish:['fun'],mid:['fun','long'],long:['long'],glider:['glider'],soft:['wide'],sup:['wide'],body:['body'],nipper:['nipper']}[shape]||['fun'];
  if(!['body','nipper'].includes(shape)&&carry!=='single')keys=[carry];
  const hits=[];
  for(const key of keys){
   const family=data.find(f=>f.key===key);if(!family)continue;
   if(width&&family.width&&width>family.width)continue;
   const special=key==='body'||key==='nipper';
   const size=family.sizes.find(n=>length<=n+(family.extraLength??(special?0:2)));
   if(!size)continue;
   if(key==='nipper'&&Math.abs(length-78)>0.05)continue;
   hits.push({family,size,length,width,carry,special});
  }
  return hits.length?{best:hits[0],alternatives:hits.slice(1)}:{error:'no_match',contact:true};
 }
 class BagSelector extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   try{this.data=JSON.parse(this.querySelector('[data-fit-data]').textContent);}catch(e){return;}
   this.copy=JSON.parse(this.querySelector('[data-fit-copy]').textContent);this.form=this.querySelector('form');this.result=this.querySelector('[data-fit-result]');this.unit='imperial';this.lastShape=this.form.shape.value;
   const p=new URLSearchParams(location.search);
   if(this.dataset.initialShape)this.form.shape.value=this.dataset.initialShape;
   if(this.dataset.initialCarry)this.form.carry.value=this.dataset.initialCarry;
   const initialLength=Number(this.dataset.initialLength);
   if(initialLength){if(this.form.shape.value==='body')this.form.bodylength.value=initialLength;else{this.form.feet.value=Math.floor(initialLength/12);this.form.inches.value=initialLength%12;}}
   if(p.has('sv_shape')&&Array.from(this.form.shape.options).some(o=>o.value===p.get('sv_shape')))this.form.shape.value=p.get('sv_shape');
   if(p.has('sv_length')){const n=Number(p.get('sv_length'));if(n>=12&&n<156){if(this.form.shape.value==='body')this.form.bodylength.value=n;else{this.form.feet.value=Math.floor(n/12);this.form.inches.value=n%12;}}}
   if(p.has('sv_width'))this.form.width.value=Number(p.get('sv_width'))/2.54||'';
   if(p.has('sv_carry')&&Array.from(this.form.carry.options).some(o=>o.value===p.get('sv_carry')))this.form.carry.value=p.get('sv_carry');
   this.form.addEventListener('submit',e=>e.preventDefault());
   this.form.addEventListener('change',e=>{if(e.target.name==='units')this.convertUnits();if(e.target.name==='shape')this.changeShape();this.render();});
   this.form.addEventListener('input',e=>{if(e.target.tagName==='INPUT')this.render();});
   this.lastShape=this.form.shape.value;this.render();
  }
  changeShape(){const f=this.form,shape=f.shape.value;if(f.units.value==='cm'){if(shape==='body')f.lengthcm.value=(Number(f.bodylength.value)*2.54).toFixed(2);else if(this.lastShape==='body')f.lengthcm.value=((Number(f.feet.value)*12+Number(f.inches.value))*2.54).toFixed(2);}this.lastShape=shape;}
  t(key,values={}){return (this.copy[key]||key).replace(/\{(\w+)\}/g,(_,k)=>values[k]??'');}
  measure(){const f=this.form;return f.units.value==='cm'?Number(f.lengthcm.value)/2.54:f.shape.value==='body'?Number(f.bodylength.value):Number(f.feet.value)*12+Number(f.inches.value);}
  convertUnits(){const f=this.form;const old=this.unit;const n=old==='cm'?Number(f.lengthcm.value)/2.54:f.shape.value==='body'?Number(f.bodylength.value):Number(f.feet.value)*12+Number(f.inches.value);const w=Number(f.width.value);this.unit=f.units.value;if(this.unit==='cm'){f.lengthcm.value=Math.round(n*2.54*100)/100;if(w)f.width.value=Math.round(w*2.54*100)/100;}else{f.feet.value=Math.floor(n/12);f.inches.value=Math.round((n%12)*100)/100;f.bodylength.value=Math.round(n*10)/10;if(w)f.width.value=Math.round(w/2.54*100)/100;}}
  href(product,variant,length,width){const url=new URL(product.url,location.origin);const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);if(variant)url.searchParams.set('variant',variant.id.split('/').pop());url.searchParams.set('sv_shape',this.form.shape.value);url.searchParams.set('sv_length',Math.round(length*100)/100);if(width)url.searchParams.set('sv_width',Math.round(width*100)/100);url.searchParams.set('sv_carry',this.form.carry.value);return url.href;}
  contact(length,width){return 'https://www.summervibes.com.au/pages/contact?'+new URLSearchParams({board_length:Number.isFinite(length)?ft(length):'',board_width:width?width.toFixed(1)+' cm':'',board_shape:this.form.shape.value});}
  productChoice(family,size){const choices=family.products.filter(p=>p.status==='ACTIVE').flatMap(p=>p.variants.filter(v=>v.length===size).map(v=>({p,v})));return choices.find(c=>c.v.availableForSale)||choices[0];}
  render(){
   const f=this.form,shape=f.shape.value,cm=f.units.value==='cm',body=shape==='body',special=body||shape==='nipper';
   this.querySelector('[data-imperial]').hidden=cm||body;this.querySelector('[data-centimetres]').hidden=!cm;this.querySelector('[data-body]').hidden=cm||!body;
   this.querySelector('[data-width-unit]').textContent=cm?'cm':this.t('inches');f.carry.disabled=special;if(special)f.carry.value='single';
   const length=this.measure(),rawWidth=Number(f.width.value),width=rawWidth*(cm?1:2.54);
   let answer=matchBag(this.data,shape,length,width,f.carry.value);
   const inches=Number(f.inches.value);
   if(!cm&&!body&&(f.inches.value===''||inches<0||inches>=12))answer={error:'invalid_inches'};
   if((f.width.value!==''&&(!Number.isFinite(width)||width<=0||width>160))||length>180)answer={error:'invalid_measurements'};
   if(answer.error){this.result.innerHTML='<div class="fit-step"><span class="fit-number">2</span>'+esc(this.t('size_step'))+'</div><p class="fit-error">'+esc(this.t(answer.error))+'</p><a class="fit-cta" href="'+esc(this.contact(length,width))+'">'+esc(this.t('ask_fit'))+'</a>';this.browse(length,width);return;}
   const {family,size}=answer.best,choice=this.productChoice(family,size),max=size+(family.extraLength??(answer.best.special?0:2));
   const sizeText=family.key==='body'?'44″':ft(size);
   let reason=this.t('standard_reason',{length:ft(length),max:ft(max)});
   if(length<size-6)reason=this.t('smallest_reason');
   if(body)reason=this.t('body_reason');
   if(shape==='nipper')reason=this.t('nipper_reason');
   let check=family.width?this.t('known_width',{width:family.width}):this.t('unknown_width');
   if(width)check=this.t('your_width',{inches:(width/2.54).toFixed(1),cm:width.toFixed(1)})+check;
   if(f.carry.value!=='single')check+=this.t('travel_check');
   if(f.carry.value!=='single'&&['long','sup','soft','glider'].includes(shape))check+=this.t('travel_shape');
   const button=choice?'<a class="fit-cta" href="'+esc(this.href(choice.p,choice.v,length,width))+'">'+esc(this.t('view_bag',{size:sizeText,family:family.name}))+'</a><p class="fit-extra">'+(choice.v.availableForSale?this.t('available'):this.t('unavailable'))+'</p>':'<a class="fit-cta" href="'+esc(this.contact(length,width))+'">'+esc(this.t('ask_size'))+'</a><p class="fit-extra">'+esc(this.t('incoming'))+'</p>';
   let alternative='';for(const a of answer.alternatives){const c=this.productChoice(a.family,a.size);if(c)alternative+='<div class="fit-alt">'+esc(this.t('alternative_intro'))+'<a href="'+esc(this.href(c.p,c.v,length,width))+'">'+esc(this.t('see_bag',{size:ft(a.size),family:a.family.name}))+'</a></div>';}
   this.result.innerHTML='<div class="fit-step"><span class="fit-number">2</span>'+esc(this.t('size_step'))+'</div><span class="fit-tag">'+esc(this.t('match_tag'))+'</span><div class="fit-size">'+sizeText+'</div><h3 class="fit-family">'+esc(family.name)+'</h3><p class="fit-reason">'+esc(reason)+'</p><div class="fit-check">'+esc(check)+'</div>'+button+alternative;
   this.browse(length,width);
  }
  browse(length,width){this.querySelector('[data-fit-browse]').innerHTML=this.data.map(f=>{const p=f.products.find(p=>p.status==='ACTIVE');return '<a class="fit-bag" href="'+esc(p?this.href(p,null,length,width):this.contact(length,width))+'"><b>'+esc(f.name)+'</b><span>'+esc(f.capacity)+' · '+(f.key==='body'?this.t('up_to_44'):f.sizes.map(ft).join(' / '))+'</span>'+(!p?'<em>'+esc(this.t('ask_availability'))+'</em>':'')+'</a>';}).join('');}
 }
 if(!customElements.get('sv-bag-selector'))customElements.define('sv-bag-selector',BagSelector);
 if(typeof module!=='undefined')module.exports={matchBag,ft};
 // Recompute after browsers restore form values during Back/Forward navigation.
 window.addEventListener('pageshow',()=>setTimeout(()=>document.querySelectorAll('sv-bag-selector').forEach(el=>{if(el.ready&&el.form){el.unit=el.form.units.value;el.lastShape=el.form.shape.value;el.render();}}),0));
 window.SVBagFit={matchBag,ft};
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-colour-launch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sv-colour-launch')) {
    customElements.define('sv-colour-launch',class extends HTMLElement {
      connectedCallback() {
        if(this.initialized) return;
        this.initialized=true;
        this.button=this.querySelector('.sv-colour-launch__pause');
        this.reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused=false;
        this.visible=true;
        this.sync=()=>{
          this.dataset.running=String(!this.paused && this.visible && !document.hidden && !this.reduced.matches);
          if(this.button) {
            this.button.setAttribute('aria-pressed',String(this.paused));
            this.button.querySelector('[data-motion-label]').textContent=this.paused?this.button.dataset.playLabel:this.button.dataset.pauseLabel;
            this.button.querySelector('[data-motion-icon]').textContent=this.paused?'▷':'Ⅱ';
            this.button.hidden=this.reduced.matches;
          }
          this.syncBloom?.();
        };
        this.toggle=()=>{this.paused=!this.paused;this.sync();};
        this.preference=()=>this.sync();
        this.button?.addEventListener('click',this.toggle);
        document.addEventListener('visibilitychange',this.sync);
        this.reduced.addEventListener('change',this.preference);
        this.setupBloom();
        this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.1});
        this.observer.observe(this);
        this.sync();
      }
      setupBloom() {
        if(this.dataset.bloomEnabled!=='true') return;
        if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const panels=[...this.querySelectorAll('.sv-colour-launch__image')];
        if(!panels.length) return;
        this.dataset.bloom='ready';
        const MIN_SAT=.5, MAX_SAT=1.3;      /* start greyed, finish rich */
        const END=.55;
        const MIN_TRAVEL=.15;
        const DRIFT_DELAY=300, DRIFT_TIME=2500; /* if nobody scrolls, colour fills in on its own over ~2.5s */
        const clamp=(v)=>Math.min(1,Math.max(0,v));
        const ease=(t)=>t<.5?2*t*t:1-Math.pow(-2*t+2,2)/2;
        const items=panels.map(el=>({el,cur:0,best:0,base:0,span:1,seenAt:null,pauseCentre:null}));
        let last=performance.now(), elapsed=0, running=false, frame=null;
        const canRun=()=>this.isConnected && this.bloomVisible && !this.paused && !document.hidden && !this.reduced.matches;
        const paint=(it)=>{
          const k=it.cur;
          it.el.style.filter=`saturate(${(MIN_SAT+(MAX_SAT-MIN_SAT)*k).toFixed(3)}) contrast(${(1+.05*k).toFixed(3)}) brightness(${(1.05-.05*k).toFixed(3)})`;
        };
        const tick=(now)=>{
          frame=null;
          if(!canRun()) { stop(); return; }
          const dt=Math.min(.1,(now-last)/1000);
          elapsed+=now-last;
          last=now;
          const vh=window.innerHeight||1;
          let pending=false;
          items.forEach(it=>{
            if(it.cur>=.999) return;
            pending=true;
            const r=it.el.getBoundingClientRect();
            const centre=r.top+r.height/2;
            if(it.seenAt===null && r.top<vh && r.bottom>0){ it.seenAt=elapsed; it.base=centre; it.span=Math.max(vh*MIN_TRAVEL,centre-vh*END); }
            if(it.seenAt===null) return;
            const fromScroll=clamp((it.base-centre)/it.span);   /* share of the scroll distance travelled since first seen */
            const fromTime=ease(clamp((elapsed-it.seenAt-DRIFT_DELAY)/DRIFT_TIME));
            it.best=Math.max(it.best,fromScroll,fromTime);   /* never goes back to grey */
            it.cur+=(it.best-it.cur)*Math.min(1,dt*6);       /* soft follow so a fast flick still glides */
            if(it.best>=1 && it.cur>.995) it.cur=1;
            paint(it);
          });
          if(pending){ frame=requestAnimationFrame(tick); } else { running=false; }
        };
        const stop=()=>{
          if(!running) return;
          running=false;
          if(frame!==null) cancelAnimationFrame(frame);
          frame=null;
          items.forEach(it=>{
            if(it.seenAt===null) return;
            const r=it.el.getBoundingClientRect();
            it.pauseCentre=r.top+r.height/2;
          });
        };
        const start=()=>{
          if(running || !canRun()) return;
          items.forEach(it=>{
            if(it.pauseCentre===null) return;
            const r=it.el.getBoundingClientRect();
            it.base+=r.top+r.height/2-it.pauseCentre;
            it.pauseCentre=null;
          });
          running=true;
          last=performance.now();
          frame=requestAnimationFrame(tick);
        };
        this.syncBloom=()=>canRun()?start():stop();
        this.stopBloom=stop;
        this.bloomVisible=false;
        this.bloomObserver=new IntersectionObserver(entries=>{
          this.bloomVisible=entries[0].isIntersecting;
          this.syncBloom();
        },{rootMargin:'100px 0px'});
        this.bloomObserver.observe(this);
      }
      disconnectedCallback() {
        this.stopBloom?.();
        this.bloomObserver?.disconnect();
        this.initialized=false;
        this.observer?.disconnect();
        this.button?.removeEventListener('click',this.toggle);
        document.removeEventListener('visibilitychange',this.sync);
        this.reduced.removeEventListener('change',this.preference);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-home-categories"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = () => {
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches || !matchMedia('(max-width: 749px), (hover: none)').matches) return;
    document.querySelectorAll('.sv-home-categories:not([data-colour-ready])').forEach(section => {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          setTimeout(() => entry.target.classList.add('is-colour-revealed'), 180);
          observer.unobserve(entry.target);
        });
      }, {threshold:.3});
      section.setAttribute('data-colour-ready', '');
      section.querySelectorAll('.sv-home-categories__card').forEach(card => observer.observe(card));
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-review-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sv-review-strip')) {
    customElements.define('sv-review-strip', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const source = this.querySelector('[data-review-source]');
        const track = this.querySelector('.sv-review-strip__track');
        if (!source || !track) return;
        const reviews = [...source.content.querySelectorAll('.jdgm-carousel-item')];
        const seen = new Set();
        const fragment = document.createDocumentFragment();
        const textNode = (tag, className, text) => {
          const node = document.createElement(tag);
          node.className = className;
          node.textContent = text;
          return node;
        };
        reviews.forEach(review => {
          const id = review.dataset.reviewId;
          const body = review.querySelector('.jdgm-carousel-item__review-body')?.textContent.trim();
          const name = review.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim();
          const rating = review.querySelector('.jdgm-carousel-item__review-rating')?.getAttribute('aria-label');
          if (!body || !name || !rating || (id && seen.has(id))) return;
          if (id) seen.add(id);
          const card = document.createElement('article');
          card.className = 'sv-review-strip__card';
          card.setAttribute('role', 'listitem');
          if (id) card.dataset.reviewId = id;
          const stars = textNode('p', 'sv-review-strip__stars', '★ ' + rating);
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          summary.append(textNode('span', 'sv-review-strip__quote', body));
          summary.append(textNode('span', 'sv-review-strip__toggle sv-review-strip__open', this.dataset.readLabel));
          summary.append(textNode('span', 'sv-review-strip__toggle sv-review-strip__close', this.dataset.closeLabel));
          details.append(summary);
          const product = review.querySelector('.jdgm-carousel-item__product-title')?.textContent.trim() || review.querySelector('.jdgm-carousel-item__product-image')?.getAttribute('alt') || this.dataset.storeLabel;
          card.append(stars, details, textNode('p', 'sv-review-strip__name', name), textNode('p', 'sv-review-strip__product', product));
          fragment.append(card);
        });
        if (!fragment.children.length) return;
        track.append(fragment);
        track.hidden = false;
        const arrows = this.querySelector('.sv-review-strip__arrows');
        const buttons = [...arrows.querySelectorAll('button')];
        arrows.hidden = false;
        const sync = () => {
          buttons[0].disabled = track.scrollLeft <= 2;
          buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const distance = track.firstElementChild.getBoundingClientRect().width + 14;
          track.scrollBy({left:Number(button.dataset.direction) * distance, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }));
        track.addEventListener('scroll', sync, {passive:true});
        this.resizeObserver = new ResizeObserver(sync);
        this.resizeObserver.observe(track);
        sync();
        this.ready = true;
      }
      disconnectedCallback() { this.resizeObserver?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
